import routerUtils from '../../../../lib/routerUtils'

import Closer from '../../../../shared_components/core/closer/Closer'

const CreditCardModalCloser = () => <Closer closer={routerUtils.goBack} />

export default CreditCardModalCloser
